import * as r from "react";
import { c as a } from "./retry-CQhdo0pz.js";
const e = a(5);
function m(t) {
  return r.lazy(() => e(t));
}
export {
  m as default
};
